import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import { CompanyProvider } from './components/CompanyContext';
import { UserProvider } from './components/UserContext';
import CompanyGuard from './components/CompanyGuard';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CompaniesList from './components/companies/CompaniesList';
import CompanyForm from './components/companies/CompanyForm';
import CompanyDetail from './components/companies/CompanyDetail';
import UsersList from './components/users/UsersList';
import UserForm from './components/users/UserForm';
import UserDetail from './components/users/UserDetail';
import EmployeesList from './components/employees/EmployeesList';
import OrdersList from './components/orders/OrdersList';
import OrderForm from './components/orders/OrderForm';
import OrderDetail from './components/orders/OrderDetail';
import ProductsList from './components/products/ProductsList';
import ProductForm from './components/products/ProductForm';
import ProductDetail from './components/products/ProductDetail';
import SalesList from './components/sales/SalesList';
import SaleDetail from './components/sales/SaleDetail';
import SaleForm from './components/sales/SaleForm';
import CustomersList from './components/customers/CustomersList';
import CustomerForm from './components/customers/CustomerForm';
import CustomerDetail from './components/customers/CustomerDetail';
import SubscriptionsList from './components/subscriptions/SubscriptionsList';
import SubscriptionForm from './components/subscriptions/SubscriptionForm';
import SubscriptionDetail from './components/subscriptions/SubscriptionDetail';
import CurrenciesList from './components/currencies/CurrenciesList';
import CurrencyForm from './components/currencies/CurrencyForm';
import CurrencyDetail from './components/currencies/CurrencyDetail';
import LocationsList from './components/locations/LocationsList';
import LocationForm from './components/locations/LocationForm';
import LocationDetail from './components/locations/LocationDetail';
import LoansList from './components/loans/LoansList';
import LoanForm from './components/loans/LoanForm';
import LoanDetail from './components/loans/LoanDetail';
import Reporting from './components/Reporting';
import Settings from './components/Settings';
import './App.css';
import { ToastProvider } from './components/ToastProvider';

function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <CompanyProvider>
          <ToastProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <CompanyGuard>
                      <Layout>
                        <Routes>
                          <Route path="/" element={<Dashboard />} />
                          <Route path="/companies" element={<CompaniesList />} />
                          <Route path="/companies/new" element={<CompanyForm />} />
                          <Route path="/companies/:id" element={<CompanyDetail />} />
                          <Route path="/companies/:id/edit" element={<CompanyForm />} />
                          <Route path="/users" element={<UsersList />} />
                          <Route path="/users/new" element={<UserForm />} />
                          <Route path="/users/:id" element={<UserDetail />} />
                          <Route path="/users/:id/edit" element={<UserForm />} />
                          <Route path="/employees" element={<EmployeesList />} />
                          <Route path="/orders" element={<OrdersList />} />
                          <Route path="/orders/new" element={<OrderForm />} />
                          <Route path="/orders/:id" element={<OrderDetail />} />
                          <Route path="/orders/:id/edit" element={<OrderForm />} />
                          <Route path="/products" element={<ProductsList />} />
                          <Route path="/products/new" element={<ProductForm />} />
                          <Route path="/products/:id" element={<ProductDetail />} />
                          <Route path="/products/:id/edit" element={<ProductForm />} />
                          <Route path="/customers" element={<CustomersList />} />
                          <Route path="/customers/new" element={<CustomerForm />} />
                          <Route path="/customers/:id" element={<CustomerDetail />} />
                          <Route path="/customers/:id/edit" element={<CustomerForm />} />
                          <Route path="/subscriptions" element={<SubscriptionsList />} />
                          <Route path="/subscriptions/new" element={<SubscriptionForm />} />
                          <Route path="/subscriptions/:id" element={<SubscriptionDetail />} />
                          <Route path="/subscriptions/:id/edit" element={<SubscriptionForm />} />
                          
                          {/* Currencies Routes */}
                          <Route path="/currencies" element={<CurrenciesList />} />
                          <Route path="/currencies/new" element={<CurrencyForm />} />
                          <Route path="/currencies/:id" element={<CurrencyDetail />} />
                          <Route path="/currencies/:id/edit" element={<CurrencyForm />} />
                          {/* Locations Routes */}
                          <Route path="/locations" element={<LocationsList />} />
                          <Route path="/locations/new" element={<LocationForm />} />
                          <Route path="/locations/:id" element={<LocationDetail />} />
                          <Route path="/locations/:id/edit" element={<LocationForm />} />
                          
                          {/* Loans Routes */}
                          <Route path="/loans" element={<LoansList />} />
                          <Route path="/loans/new" element={<LoanForm />} />
                          <Route path="/loans/:id" element={<LoanDetail />} />
                          <Route path="/loans/:id/edit" element={<LoanForm />} />
                          
                          <Route path="/sales" element={<SalesList />} />
                          <Route path="/sales/new" element={<SaleForm />} />
                          <Route path="/sales/:id" element={<SaleDetail />} />
                          <Route path="/reporting" element={<Reporting />} />
                          <Route path="/settings" element={<Settings />} />
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </Layout>
                    </CompanyGuard>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
          </ToastProvider>
        </CompanyProvider>
      </UserProvider>
    </AuthProvider>
  );
}

export default App;
